import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import useArticle from '../../hooks/use_article';
import useDraggableScroll from '../../hooks/use_draggable_scroll';
import useGroup from '../../hooks/use_group';
import useTranslation from '../../hooks/use_translation';
import { getVariantByLanguage } from '../../utils/helpers';
import ArticlesListItem from './articles-list-item';

const ArticlesHorizontalList = ({
	children,
	include_articles,
	include_groups,
	include_markers,
	include_products,
	limit,
}) => {
	let empty = true;
	const { items: articles } = useArticle({
		include_articles,
		include_groups,
		include_markers,
		include_products,
		include_types: ['blog'],
		limit,
	});
	const { items: groups_data } = useGroup();
	const { language } = useTranslation('component_articles_list');
	const ref = useRef(null);
	const { onMouseDown } = useDraggableScroll(ref, { direction: 'horizontal' });

	const component = (
		<div className="d-flex w-100">
			{articles.map((article, index) => {
				let group = null;
				if (limit && index >= limit - 1) return;
				const article_variant = getVariantByLanguage(
					language,
					article.article_variants,
				);
				if (!article_variant) return;

				if (article.groups && article.groups.length) {
					group = groups_data.find(
						(value) => value.group_id == article.groups[0],
					);
				}

				const image_header = article?.fields?.files_header_url_src;
				if (empty) empty = false;
				return (
					<ArticlesListItem
						article_id={article.article_id}
						className="grid-slider"
						excerpt={article_variant.excerpt}
						group={{
							groups: article.groups,
							title: group?.group_variant?.title,
						}}
						image_header={image_header}
						key={index}
						page="artiklar"
						published_at={article.published_at.substring(0, 10)}
						slug={article_variant.slug}
						title={article_variant.title}
					/>
				);
			})}
		</div>
	);

	return children ? <>{children(empty ? null : component)}</> : component;
};

ArticlesHorizontalList.propTypes = {
	children: PropTypes.any,
	include_articles: PropTypes.array,
	include_groups: PropTypes.array,
	include_markers: PropTypes.array,
	include_products: PropTypes.array,
	limit: PropTypes.number,
};

export default ArticlesHorizontalList;
